import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchPartnerUser } from '@/features/users/api'

import { partnerUserParamsSchema } from '../-models/partner-user-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/$userId'
)({
  parseParams: (params) => parse(partnerUserParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, userId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      user: await fetchPartnerUser(
        {
          tenantKey,
          userId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.user.displayName
    }
  ]
})
